import React, { useState } from 'react';
import { View, TouchableOpacity } from 'react-native';
import TextLato from '../text/text-lato/TextLato';
import { styles } from './OptionSelector.styles';

export interface OptionSelectorOption {
  label: string;
  value: string | number;
}

interface OptionSelectorProps {
  options: OptionSelectorOption[];
  onChange?: (value: string | number) => void;
  defaultValue?: string | number;
  testID?: string;
}

export default function OptionSelector({ options = [], onChange, defaultValue, testID }: OptionSelectorProps) {
  const [selected, setSelected] = useState<string | number>(defaultValue ?? options[0]?.value);

  const handlePress = (value: string | number) => {
    setSelected(value);
    onChange?.(value);
  };

  return (
    <View style={styles.container} testID={testID}>
      {options.map(option => {
        const isActive = selected === option.value;
        return (
          <TouchableOpacity
            key={option.value.toString()}
            style={[styles.option, isActive && styles.activeOption]}
            onPress={() => handlePress(option.value)}
          >
            <TextLato numberOfLines={1} style={[styles.text, isActive && styles.activeText]}>
              {option.label}
            </TextLato>
          </TouchableOpacity>
        );
      })}
    </View>
  );
}
